module.exports = __webpack_public_path__ + "static/img/ZIP.2f5febec.png";